import React from 'react';
import { FileStack, GitMerge, Archive } from 'lucide-react';

const CARDS = [
  {
    icon: FileStack,
    title: 'Mixed discipline scan dump',
    body:
      "A subcontractor sends a zip of 300 scanned drawings. They're all in one folder: scan_0001.pdf through scan_0312.pdf, mixing architectural, structural, plumbing, and telecom drawings. Someone has to open each one, decide if it's AR or ST or PW or TR, rename it, and file it in the right discipline subfolder. That's most of a day, every time a subcontractor delivers.",
  },
  {
    icon: GitMerge,
    title: 'CRF revisions overwriting each other',
    body:
      'Change request CRF-Change_Request_form-0020 lands in the project folder. Two weeks later, a revised version with the same base name arrives from the contractor. Someone drops it in the same folder. The old revision is gone. By the time the discrepancy surfaces in a coordination meeting, three more change requests have done the same thing.',
  },
  {
    icon: Archive,
    title: '7,000 file archive with no taxonomy',
    body:
      'A telecom archiving project for a ministry client accumulates 7,000+ files over a year: drawings, BOQs, MOMs, AutoCAD plot logs, RFIs, contractor submittals, photos, bilingual Arabic and English documents. By the time the project closes, nobody can find anything. Handoff to the client takes weeks instead of hours.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The engineering filing problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three patterns we hear from every AEC, telecom, and infrastructure project manager.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-10 max-w-3xl mx-auto text-center text-apple-300 text-sm leading-relaxed">
        <p>
          Engineering project archives are not just big. They're heterogeneous: DWG drawings,
          PDF submittals, Excel BOQs, Word MOMs, photo logs, change request forms, contractor
          deliverables, owner correspondence. Sortio understands each file type and routes them
          into a taxonomy your team already uses, instead of forcing your team into a new tool.
        </p>
      </div>
    </section>
  );
};

export default PainPoints;
